import billingModule from '../../billing.module';
import template from './billingModalResendActivationEmail.component.html';
import style from './billingModalResendActivationEmail.component.css';

export default billingModule.component('billingModalResendActivationEmail', {
    template,
    style,
    bindings: {
        close: '&',
        dismiss: '&',
        modalInstance: '<',
        resolve: '<'
    },
    controller(
        accountService,
        asLoadingMask,
        asNotifier,
        stringHelper,
        textResources,
        systemApiService,
        vcRecaptchaService
    ) {
        var vm = this;

        vm.$onInit = () => {
            systemApiService.getConfigurations().then(data => {
                vm.recaptchaSiteKey = data['google.recaptcha.sitekey'];
            });
        };

        vm.checkRecaptchaBeforeResendActivationEmail = () => {
            if (
                vm.recaptchaSiteKey === undefined ||
                vm.recaptchaSiteKey === null ||
                vm.recaptchaSiteKey === ''
            ) {
                showSendActivationEmailFailed();

                return;
            }

            vcRecaptchaService.execute(vm.recaptchaWidgetId);
        };

        vm.resendActivationEmail = recaptchaResponse => {
            asLoadingMask.show();
            accountService
                .resendActivationEmail(recaptchaResponse)
                .then(
                    () => {
                        asNotifier.success(
                            stringHelper.format(
                                textResources.billingResendActivationEmailSuccess,
                                { email: vm.resolve.email }
                            )
                        );
                    },
                    () => {
                        showSendActivationEmailFailed();
                    }
                )
                .finally(() => {
                    asLoadingMask.hide();
                    vm.close();
                });
        };

        vm.cbExpiration = () => {
            vcRecaptchaService.reload(vm.recaptchaWidgetId);
            vm.recaptchaResponse = null;
        };

        vm.setWidgetId = widgetId => {
            vm.recaptchaWidgetId = widgetId;
        };

        function showSendActivationEmailFailed() {
            asNotifier.error(textResources.billingResendActivationEmailFailed);
        }
    }
});



// WEBPACK FOOTER //
// ./modules/billing/components/billing-modal-resend-activation-email/billingModalResendActivationEmail.component.js